<template>
    <div class="button-area">
        <div class="title">
            金盒子自动化测试系统
            <br/>
            [版本: 1.0.3]
        </div>
        <div
            v-on:click="markCupboard"
            class="big-button"
            style="background-color: #E73C70;">
            标记
        </div>
        <div
            v-on:click="openDoor"
            class="big-button"
            style="background-color: #EA5839;">
            开门
        </div>
        <div
            v-on:click="test"
            class="big-button"
            style="background-color: #5CC9F5;">
            测试
        </div>
        <div
            v-on:click="activation"
            class="big-button"
            style="background-color: #4AF2A1;">
            出厂激活
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';
 import Input from "ant-design-vue/lib/input";

 import 'vue2-toast/lib/toast.css';
 import Toast from 'vue2-toast';

 Vue.use(Toast, {
     type: 'center',
     duration: 5000,
     wordWrap: true,
     width: '150px'
 });

 Vue.component(Input.name, Input);

 export default {
     name: 'Home',
     props: {
     },
     components: {
     },
     mounted() {
         if (sessionStorage.getItem("openDoor") == "success") {
             this.$toast.center('开门成功');
             sessionStorage.setItem("openDoor", "")
         } else if (sessionStorage.getItem("openDoor") == "failed") {
             this.$toast.center('开门失败: ' + sessionStorage.getItem("openDoorFailedReason"))
             sessionStorage.setItem("openDoor", "")
             sessionStorage.setItem("openDoorFailedReason", "")
         }

         if (sessionStorage.getItem("testResult") == "failed") {
             this.$toast.center('检测失败: ' + sessionStorage.getItem("testResultFailedReason"))
             sessionStorage.setItem("testResult", "")
             sessionStorage.setItem("testResultFailedReason", "")
         }

         if (sessionStorage.getItem("bindResult") == "failed") {
             this.$toast.center('激活失败: ' + sessionStorage.getItem("bindResultFailedReason"))
             sessionStorage.setItem("bindResult", "")
             sessionStorage.setItem("bindResultFailedReason", "")
         }

         if (sessionStorage.getItem("fetchTag") == "failed") {
             this.$toast.center('获取编号失败: ' + sessionStorage.getItem("fetchTagFailedReason"))
             sessionStorage.setItem("fetchTag", "")
             sessionStorage.setItem("fetchTagFailedReason", "")
         }
     },
     methods: {
         markCupboard() {
             this.$router.push("/markCupboard")
         },
         openDoor() {
             this.$router.push("/opendoor")
         },
         test() {
             this.$router.push("/testscan")
         },
         activation() {
             this.$router.push("/bindscandevice")
         }
     }
 }
</script>

<style scoped>
 .title {
     font-size: 30px;
     margin-top: 20px;
     margin-bottom: 20px;
 }

 .button-area {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: space-around;
     width: 100%;
     height: 100%;
 }

 .big-button {
     font-size: 30px;
     width: 80%;
     border-radius: 5px;
     height: 15%;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     color: #FFF;
     box-shadow: #B4B4B4 0 0 10px 0;
 }

 .big-button:last-child {
     margin-bottom: 20px;
 }
</style>
